<template>
  <div class="role-basic-permissions">
    <Row class="strech-oriental" :gutter="32">
      <i-col span="12" class="tree-col">
        <div class="tree-col-title">
          权限列表
        </div>
        <Tree :data="permissions" show-checkbox multiple
          @on-check-change="checkChange"
          class="strech-tree"></Tree>
      </i-col>
      <!-- <i-col span="2" class="transfer-controls">
        <Button><Icon type="ios-arrow-forward" /></Button>
        <div class="padding-top-20"></div>
        <Button><Icon type="ios-arrow-back" /></Button>
      </i-col> -->
      <i-col span="12" class="transfer-targets tree-col">
        <Form ref="basicPermissionForm" :model="basicPermission" :rules="rules" :label-width="80" inline class="new-perimission-form">
          <FormItem prop="name" label="权限名称">
            <span>{{basicPermission.name}}</span>
          </FormItem>
          <Button type="success" @click="submit">保存</Button>
          <FormItem prop="permissionsArr" style="width:100%;">
            <input type="hidden" v-model="basicPermission.permissionsArr" />
          </FormItem>
        </Form>
        <div class="tree-col-title">
          已选权限列表
        </div>
        <Tree :data="basicPermission.permissionsArr"
          class="strech-tree"></Tree>
      </i-col>
    </Row>
  </div>
</template>

<script>
import Api from './../../api/Api'
export default {
  name: 'role-basic-permissions',
  data () {
    const validatePermissions = (rule, value, callback) => {
      if (!(value instanceof Array) || !value.length) {
        callback(new Error('请选择权限'))
      } else {
        if (callback) {
          callback()
        }
      }
    }
    return {
      permissions: [],
      rolePermissions: [],
      basicPermission: {
        tid: null,
        name: '',
        permissions: '',
        permissionsArr: []
      },
      rules: {
        name: [
          { required: true, message: '请填权限名称', trigger: 'blur' }
        ],
        permissionsArr: [
          { validator: validatePermissions, trigger: 'blur'}
        ]
      }
    }
  },
  computed: {
    selected () {
      return []
    }
  },
  async mounted () {
    if (!this.$route.params.role) {
      this.$Modal.error({
        title: '错误',
        content: '角色信息不存在'
      })
    } else {
      this.basicPermission.tid = this.$route.params.role.tid
      this.basicPermission.name = this.$route.params.role.name
      await this.initRolePermissionList()
      await this.initPermissionList()
    }
  },
  methods: {
    async initRolePermissionList () {
      return new Promise((resolve, reject) => {
        this.$Spin.show()
        Api.BasicPermission.listRolePermissions(this.$route.params.role.tid)
        .then(perms => {
          this.$Spin.hide()
          this.rolePermissions = perms.map((p) => {
            p.title = `[${p.name}] - ${p.controller}/${p.action}`
            p.expand = true
            return p
          })
          this.basicPermission.permissionsArr = this.rolePermissions
          resolve(this.rolePermissions)
        }).catch(err => {
          this.$Spin.hide()
          this.$Message.error('获取权限列表失败!' + err.message)
          reject(err)
        })
      })
    },
    async initPermissionList () {
      return new Promise((resolve, reject) => {
        this.$Spin.show()
        Api.BasicPermission.listBasicPermissions({}, 1, 1000)
        .then(perms => {
          this.$Spin.hide()
          this.permissions = perms.data.map((p) => {
            let exists = this.rolePermissions.find(o => o.tid === p.tid)
            if (exists) {
              p.checked = true
            }
            p.title = `[${p.name}] - ${p.controller}/${p.action}`
            p.expand = true
            return p
          })
          resolve(this.permissions)
        }).catch(err => {
          this.$Spin.hide()
          this.$Message.error('获取权限列表失败!' + err.message)
          reject(err)
        })
      })
    },
    checkChange (e) {
      console.log(e)
      let valid = e
      this.basicPermission.permissionsArr = valid.map((v) => {
        return {
          title: v.title,
          tid: v.tid,
          name: v.name
        }
      })
      this.basicPermission.permissions = valid.map((v) => {
        return v.tid
      }).join(',')
    },
    submit () {
      this.$refs.basicPermissionForm.validate(async (valid) => {
        if (valid) {
          this.$Spin.show()
          let result = await Api.BasicPermission.updateRolePermissions(
            this.basicPermission.tid,
            this.basicPermission.permissions
          ).catch(err => {
            this.$Notice.error({
              title: '更新角色权限失败!',
              desc: err.message
            })
            this.$Spin.hide()
            return null
          })
          if (result) {
            this.$Message.success('更新角色权限成功!')
            this.$Spin.hide()
            await this.initRolePermissionList()
            await this.initPermissionList()
            return true
          }
        } else {
          return null
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.role-basic-permissions {
  position: relative;
  height: 100%;
  .strech-oriental {
    position: relative;
    height: 100%;
    & > .ivu-col {
      position: relative;
      height: 100%;
      overflow: auto;
    }
    .tree-col {
      display: flex;
      flex-direction: column;
      .tree-actions {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }
      .strech-tree {
        flex: 1;
        border: 1px solid #efefef;
        margin: 10px 0;
        padding: 10px;
        background: #fafafa;
      }
    }
  }
  .transfer-controls {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
}
</style>
